import React, { Component } from 'react';
import PropTypes from "prop-types";
import parse from "html-react-parser";
import {TranslationContext} from "../checkout/config/Translations";

class Translation extends Component {
  render() {
    let stub = this.props.children;
    let additionalInfo = this.props.interpolation ? this.props.interpolation : {};

    return(
      <TranslationContext.Consumer>
        {t =>
          <span>{parse(t.t(stub, additionalInfo))}</span>
        }
      </TranslationContext.Consumer>
    )
  }
}

Translation.propTypes = {
  interpolation: PropTypes.object,
};

export default Translation;
